import { gql } from '@/__generated__';

const GET_USER_MAIN_ORGANIZATION = gql(`#graphql
  query CollectionsAccessTab_GetUserMainOrganization($userId: Int) {
    user(id: $userId) {
      id
      mainOrganization {
        organization {
          id
        }
      }
    }
  }
`);

export default GET_USER_MAIN_ORGANIZATION;
